import axios from '@/utils/axios'

export function getSalesExecutives() {
    return axios.get('/sales-executives')
}

export function getSalesExecutive(id) {
    return axios.get(`/sales-executives/${id}`)
}

export function getSalesExecutiveDropdown() {
    return axios.get('/sales-executives/dropdown')
}

export function createSalesExecutive(data) {
    return axios.post('/sales-executives', data)
}

export function updateSalesExecutive(id, data) {
    return axios.put(`/sales-executives/${id}`, data)
}

export function deleteSalesExecutive(id) {
    return axios.delete(`/sales-executives/${id}`)
}